module.exports = __webpack_public_path__ + "static/media/musicCat.2f8b402e.jpg";